<template>
  <div class="IL-frame">
    <div class="" :class="selectedNode.disabled ? 'IL-frame--disabled' : ''">
      <div class="IL-frame--P">
        <h5 class="text-success">Positive outcomes</h5>
        <div class="IL-frame__PN">
          <frame-item @update="update" index="PI"/>
          <frame-item @update="update" index="PL"/>
        </div>
      </div>
      <!-- <div class="py-2" /> -->
      <div class="IL-frame--N ">
        <h5 class="text-danger">Negative outcomes</h5>
        <div class="IL-frame__PN">
          <frame-item @update="update" index="NI"/>
          <frame-item @update="update" index="NL"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import frameItem from './frameItem.vue'

export default {
  name: 'IL-Frame',
  components: {
    frameItem
  },
  computed: {
    ...mapGetters(['selectedNode'])
  },
  methods: {
    update () {
      this.$emit('update', this.selectedNode)
    }
  }
}
</script>

<style lang="scss">
  $green: #28a745;
  $red: #dc3545;
  .IL-frame {
    $parent: &;
    &--disabled {
      * {
        cursor: not-allowed;
      }
      filter: blur(3px) grayscale(75%);
      border-radius: 10px;
      cursor: not-allowed;
    }
    h4, h5 {
      margin-left: 0.25rem;
      margin-bottom: 0;
      border: 1px solid black;
      border-left: none;
      border-radius: 0 25px 25px 0;
      padding: 0.5rem 1rem;
    }
    &__PN {
      margin-left: 0.25rem;
      padding: 1rem 1rem;
      overscroll-behavior-x: contain;
    }
    &--P {
      h4, h5 {
        border-color: $green;
      }
      #{$parent} {
        &__PN {
          border-left: 2px solid $green;
        }
      }
    }
    &--N {
      h4, h5 {
        border-color: $red;
      }
      #{$parent} {
        &__PN {
          border-left: 2px solid $red;
        }
      }
    }
  }
</style>
